import { render, staticRenderFns } from "./ModalCreateCorpus.vue?vue&type=template&id=787fd7cd"
import script from "./ModalCreateCorpus.vue?vue&type=script&lang=ts"
export * from "./ModalCreateCorpus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports